"use client";
import { env } from "@/env";
import { GoogleTagManager, sendGTMEvent } from "@next/third-parties/google";
import { useEffect } from "react";
import { useConsent } from "react-hook-consent";
import Clarity from "@microsoft/clarity";

function gtag(ev: string, key: string, value: Record<string, string>) {
  window.dataLayer?.push(ev, key, value);
}

export const GAnalytics = () => {
  const consent = useConsent();

  const allowedGA = consent.hasConsent("_ga");

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];

     // Setze den Standard-Consent-Status sofort beim Laden
     window.gtag = window.gtag || function () { window.dataLayer?.push(arguments); };
     window.gtag('consent', 'default', {
       ad_storage: 'denied',
       analytics_storage: 'denied',
       functionality_storage: 'denied',
       personalization_storage: 'denied',
       security_storage: 'granted', // Sicherheits-Cookies immer erlauben
       wait_for_update: 500, // Warte 500ms auf Updates vom Cookie-Banner
     });

    window.gtag("config", "AW-1645303598");
  }, []);

  useEffect(() => {
    if (!allowedGA) {
      window.gtag("consent", "default", {
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        analytics_storage: "denied",
        functionality_storage: "denied",
        personalization_storage: "denied",
        security_storage: "granted",
      });
    }

    if (allowedGA) {
      window.gtag("consent", "default", {
        ad_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
        analytics_storage: "granted",
        functionality_storage: "granted",
        personalization_storage: "granted",
        security_storage: "granted",
      });
    }
  }, [allowedGA]);

  if (!allowedGA) {
    return null;
  }

  return (
    <>
      <GoogleTagManager gtmId={env.NEXT_PUBLIC_GANALYTICS_TRACKING_ID!} />
    </>
  );
};

export const MicrosoftClarity = () => {
  const consent = useConsent();
  const allowedClarity = consent.hasConsent("clarity");

  useEffect(() => {
    if (!allowedClarity) {
      return;
    }

    Clarity.init("qn3q0qmxr1");
    Clarity.consent();
  }, [allowedClarity]);

  return (
    <>
      {/* Clarity tracking code for https://vind.de/ */}
      <script
        dangerouslySetInnerHTML={{
          __html: `
        (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/qn3q0qmxr1?ref=bwt";
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "qn3q0qmxr1");
    `,
        }}
      />
    </>
  );
};
